import { Injectable, inject } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PLAIN_HTTP_CLIENT } from '../tokens/http-tokens';
import { AppConfigService } from './app-config.service';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigAwareTranslateLoader implements TranslateLoader {
  private readonly http = inject(PLAIN_HTTP_CLIENT) as HttpClient;
  private readonly appConfigService = inject(AppConfigService);
  private readonly localStorageService = inject(LocalStorageService);

  getTranslation(lang: string): Observable<any> {
    // lang is the GUID used by TranslateService.use(...)
    const iso1FromConfig = this.appConfigService.keyToIso1(lang);
    const iso1 =
      iso1FromConfig ??
      this.localStorageService.getItem<string>('languageISO1') ??
      'en';

    const url = this.appConfigService.localizationUrl(iso1);

    if (url) {
      return this.http.get(url).pipe(
        catchError(() => this.loadFallbackEnglish())
      );
    }

    // No URL found for this language, use English fallback from config
    return this.loadFallbackEnglish();
  }

  private loadFallbackEnglish(): Observable<any> {
    const englishUrl = this.appConfigService.localizationUrl('en');
    if (englishUrl) {
      return this.http.get(englishUrl).pipe(
        catchError((error) => {
          console.error('Failed to load English fallback translations:', error);
          return of({});
        })
      );
    }
    // If no English URL in config, return empty translations
    console.warn('No English localization URL found in config');
    return of({});
  }
}

